import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import App from 'modules/App';
import messages from 'modules/Account/messages';
import { CONNECT_DATA_SOURCE_FORM } from '../../constants';
const Field = ({ id })=>{
    const formValues = useSelector(App.selectors.formSelector(CONNECT_DATA_SOURCE_FORM));
    const onSetFormValue = useAction(App.actions.setFormValue, CONNECT_DATA_SOURCE_FORM);
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: id,
        labelMessage: messages.labels[id],
        formValues: formValues,
        children: /*#__PURE__*/ _jsx(Input, {
            type: id === 'password' ? 'password' : 'text',
            placeholder: messages.placeholders[id],
            onChange: onSetFormValue
        })
    });
};
export default /*#__PURE__*/ memo(Field);
